// extracted by mini-css-extract-plugin
export default {"wrap":"LoginForm_wrap__WCuVg","formWraper":"LoginForm_formWraper__0r4mm","formItem":"LoginForm_formItem__jGbxv"};